export function LoadingState({ message = "Loading family…" }: { message?: string }) {
  return (
    <div className="loading-state" role="status" aria-live="polite">
      <div className="loading-spinner" aria-hidden />
      <p className="title-serif">{message}</p>
    </div>
  );
}

export function ErrorState({
  message,
  onRetry,
}: {
  message: string;
  onRetry?: () => void;
}) {
  return (
    <div className="error-state" role="alert">
      <div className="error-icon" aria-hidden>
        ⚠
      </div>
      <p>{message}</p>
      {onRetry ? (
        <button type="button" className="btn-primary" onClick={onRetry}>
          Try again
        </button>
      ) : null}
    </div>
  );
}

export function EmptyState({ message }: { message: string }) {
  return (
    <div className="empty-state">
      <p className="muted">{message}</p>
    </div>
  );
}
